// ©2024 Austin App House. All rights reserved.
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import DashboardIcon from '../icons/DashboardIcon';
import { exportWorkOrders, exportBatchPayment } from '../../../storage/actions/workOrdersActions';
import prepareFilters from '../../../utils/prepareFilters';
import { getStatus } from '../../../utils/api/get/getWorkOrders';

const WorkOrderButtonControl = ({
  selectedWorkOrders, userType, exportWorkOrders, exportBatchPayment,
  search, filters, activeTab,
}) => {
  const requestData = useMemo(() => {
    const base = selectedWorkOrders.length
      ? { workOrdersId: selectedWorkOrders }
      : {
        ...search,
        filters: prepareFilters(filters),
      };
    return { ...base, ...getStatus(activeTab) };
  }, [selectedWorkOrders, search, filters, activeTab]);

  return (
    <div className="action-buttons">
      {activeTab === 'approved' && (
        <button
          className="dashboard-btn dashboard-btn--secondary"
          onClick={() => exportBatchPayment(requestData, userType)}
          aria-label="Batch Payment Export"
          type="button"
        >
          Batch Payment Export
        </button>
      )}

      <button
        className="dashboard-btn dashboard-btn--secondary"
        onClick={() => exportWorkOrders(requestData, userType)}
        aria-label="Export EXCEL"
        type="button"
      >
        <DashboardIcon name="export" size={18} strokeWidth="2" />
        Export EXCEL
      </button>
    </div>
  );
};

const mapDispatchToProps = {
  exportWorkOrders,
  exportBatchPayment,
};

const mapStateToProps = state => ({
  selectedWorkOrders: state.applicationState.selectedWorkOrders,
  activeTab: state.applicationState.activeTab,
  search: state.workOrder.searchData,
  filters: state.workOrder.filters,
});
export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderButtonControl);
